module.exports = __webpack_public_path__ + "media/male.7105910c.mp3";